import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { errMsg } from "@/lib/hsUtil";
import DateInput from "@/components/DateInput";

const toIso = v => {
  const m = String(v || "").match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  return m ? `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}` : (v || "");
};

export default function ItemEditor({ item, onClose, onSaved }) {
  const [d, setD] = useState({ start_date: item.start_date || "", end_date: item.end_date || "", done: !!item.done });
  const [busy, setBusy] = useState(false);
  async function save() {
    setBusy(true);
    try {
      await api.patch(`/programme-items/${item.id}`, { start_date: toIso(d.start_date) || null, end_date: toIso(d.end_date) || null, done: d.done });
      toast.success("Programme task saved"); onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  }
  async function del() {
    if (!window.confirm(`Delete "${item.name}" from the programme?`)) return;
    await api.delete(`/programme-items/${item.id}`); toast.success("Task deleted"); onSaved();
  }
  return (
    <div className="fixed inset-0 bg-black/80 z-40 flex items-center justify-center p-4" data-testid="prog-item-editor">
      <div className="card max-w-lg w-full space-y-3">
        <div className="flex justify-between"><h3 className="text-silver">{item.ext_id ? `${item.ext_id} · ` : ""}{item.name}</h3>
          <button onClick={onClose} className="opacity-70" data-testid="prog-editor-close">×</button></div>
        <div className="text-xs opacity-70">{[item.phase, item.trade].filter(Boolean).join(" · ")}{item.predecessors ? ` · After ${item.predecessors}` : ""}</div>
        {item.notes && <div className="text-sm opacity-80">{item.notes}</div>}
        <div className="grid grid-cols-2 gap-2">
          <label className="text-sm">Start<DateInput className="input" value={d.start_date} onChange={e => setD(x => ({ ...x, start_date: e.target.value }))} data-testid="prog-editor-start"/></label>
          <label className="text-sm">Finish<DateInput className="input" value={d.end_date} onChange={e => setD(x => ({ ...x, end_date: e.target.value }))} data-testid="prog-editor-end"/></label>
        </div>
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={d.done} onChange={e => setD(x => ({ ...x, done: e.target.checked }))} data-testid="prog-editor-done"/> Done</label>
        <div className="flex gap-2">
          <button className="btn-silver" disabled={busy} onClick={save} data-testid="prog-editor-save">Save</button>
          <button className="btn-ghost" onClick={onClose} data-testid="prog-editor-cancel">Cancel</button>
          <button className="btn-ghost text-red-400 ml-auto" onClick={del} data-testid="prog-editor-delete">Delete</button>
        </div>
      </div>
    </div>
  );
}
